import { Controller } from '@hotwired/stimulus'
import { createApp } from 'vue'
import ReservationImport from '@/components/reservation_import.vue'
import VueElementLoading from 'vue-element-loading'

export default class extends Controller {
  static targets = ['submitButton']
  connect() {
    const app = createApp(ReservationImport, {
      isImportedReservations: this.element.dataset.isImportedReservations,
      importParams: JSON.parse(this.element.dataset.importParams),
      department: JSON.parse(this.element.dataset.department),
      creatorReservations:
        JSON.parse(this.element.dataset.creatorReservations) || []
    })
    app.component('VueElementLoading', VueElementLoading)
    app.mount(this.submitButtonTarget)
  }
}
